import MainLayout from '../layouts/main';
import ProgressChartContainer from './container';

function ProgressChartPage() {
  return (
    <MainLayout title={Progress_CHART_PAGE_TITLE}>
      <ProgressChartContainer />
    </MainLayout>
  );
}

export const Progress_CHART_PAGE_TITLE = 'نمودار سیر پیشرفت';

export default ProgressChartPage;
